export enum LocalStorageKey {
  Language = 'i18nextLng',
  Audio = 'audio',
  Denom = 'ui-denom',
  AdminMode = 'admin-mode',
  NewVisitor = 'new-visitor',
  Chat = 'chat',
  CountryRestrictionIgnore = 'country-restricted-ignore',
  CompetitionRulesModal = 'competition-rules-modal',
  RegistrationModalAutoOpenWallet = 'registration-modal-auto-open-wallet',
  LastUsedWallet = 'last-used-wallet',
  EnteringMode = 'entering-mode',

  AccountStorage = 'accountV2',
  FiatCurrency = 'fiat-currency',
}

export enum SessionStorageKey {}
